/**
 * Types for action step notifications - will pair color with icon
 */
export enum ACTION_STEP_NOTIFICATION_TYPES {
  GREEN_CHECK = 'green check',
  YELLOW_ALERT = 'yellow alert',
  RED_ERROR = 'red error',
  GRAY_INFO = 'gray info',
}

/**
 * Types for linking to objects in action step notifications
 */
export enum LINK_TO_TYPES {
  NONE = 'none',
  TABLE = 'table',
  VIEW = 'view',
  WORKSPACE = 'workspace',
  PROJECT = 'project',
  FORM = 'form',
  RECORD = 'record',
  DOCUMENT = 'document',
}

/**
 * Notification target
 */
export enum NOTIFICATION_TARGET_TYPES {
  SINGLE_USER = 'single user',
  ALL_USERS = 'all users',
  ROLES = 'roles',
}

/**
 * Methods for selecting the user to notify
 */
export enum NOTIFICATION_USER_SELECT_METHODS {
  MAPPED = 'mapped',
  ENUM = 'enum',
}
